export enum ParticipantCategoryType {
        None = 0,
        NoneDescription = '',
        OverallExcludeSelf = 1,
        OverallExcludeSelfDescription = '', 
        JuniorColleagues = 2,
        JuniorColleaguesDescription = 'lang.approval.gradeBelowRespondent', 
        Peers = 3,
        PeersDescription = 'lang.approval.gradeEqualRespondent',
        SeniorColleagues = 4,
        SeniorColleaguesDescription = 'lang.approval.gradeAboveRespondent',
        Subordinates = 5,
        SubordinatesDescription = 'lang.approval.teamRespondents',
        Other = 6,
        OtherDescription = 'lang.approval.otherRespondent',
        Self = 7,
        SelfDescription = '',
        ComparisonGroup = 8,
        ComparisonGroupDescription = '',
        Overall = 9,
        OverallDescription = ''
}
